/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ---------------------------------------------------------------------------
 * Custom header cart-badge updater
 *
 * The bundled theme.js expects the header markup to contain
 * `.header__action-item--cart` and `.header__cart-count`. Our custom header
 * (sections/header.liquid) uses `.header-cart` and `.cart-badge` instead,
 * so the Cart component in theme.js never attaches its listeners and the
 * loading bar gets stuck after Add-to-Cart. This block listens for the
 * `product:added` / `cart:refresh` events dispatched by <buy-button> and
 * other theme code, updates every `.cart-badge` element from /cart.js, and
 * clears the loading bar so the UI stays in sync without a page reload.
 * ------------------------------------------------------------------------- */
(function () {
  function updateCartBadges(itemCount) {
    var badges = document.querySelectorAll('.cart-badge');
    badges.forEach(function (badge) {
      badge.textContent = itemCount;
    });
    if (window.theme) {
      window.theme.cartCount = itemCount;
    }
  }

  function refreshCartCount() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Cache-Control': 'no-cache' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        updateCartBadges(cart.item_count);
        return cart;
      })
      .catch(function (err) {
        console.warn('Cart badge refresh failed:', err);
      })
      .finally(function () {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
  }

  document.addEventListener('product:added', refreshCartCount);
  document.addEventListener('cart:refresh', refreshCartCount);
})();

/* ============================================================
   FIXED HEADER GROUP
   Announcement + Category Menu + Main Header
============================================================ */

(function () {

  function fixHeaderGroup() {

    /* Solo desktop */
    if (window.innerWidth < 1000) {
      resetHeaderGroup();
      return;
    }

    const announcement = document.querySelector('.announcement-bar-wrapper');
    const category = document.querySelector('.category-menu-wrapper');
    const header = document.querySelector('header');

    if (!announcement || !category || !header) {
      return;
    }

    /* Obtener alturas reales */
    const announcementHeight = announcement.getBoundingClientRect().height;
    const categoryHeight = category.getBoundingClientRect().height;
    const headerHeight = header.getBoundingClientRect().height;

    /* Posiciones */
    const categoryTop = announcementHeight;
    const headerTop = announcementHeight + categoryHeight;
    const totalHeight =
      announcementHeight +
      categoryHeight +
      headerHeight;

    /* --------------------------------------------------------
       ANNOUNCEMENT BAR
    -------------------------------------------------------- */

    announcement.style.setProperty(
      'position',
      'fixed',
      'important'
    );

    announcement.style.setProperty(
      'top',
      '0px',
      'important'
    );

    announcement.style.setProperty(
      'left',
      '0px',
      'important'
    );

    announcement.style.setProperty(
      'right',
      '0px',
      'important'
    );

    announcement.style.setProperty(
      'width',
      '100%',
      'important'
    );

    announcement.style.setProperty(
      'z-index',
      '10003',
      'important'
    );


    /* --------------------------------------------------------
       CATEGORY MENU
    -------------------------------------------------------- */

    category.style.setProperty(
      'position',
      'fixed',
      'important'
    );

    category.style.setProperty(
      'top',
      categoryTop + 'px',
      'important'
    );

    category.style.setProperty(
      'left',
      '0px',
      'important'
    );

    category.style.setProperty(
      'right',
      '0px',
      'important'
    );

    category.style.setProperty(
      'width',
      '100%',
      'important'
    );

    category.style.setProperty(
      'z-index',
      '10002',
      'important'
    );


    /* --------------------------------------------------------
       MAIN HEADER
    -------------------------------------------------------- */

    header.style.setProperty(
      'position',
      'fixed',
      'important'
    );

    header.style.setProperty(
      'top',
      headerTop + 'px',
      'important'
    );

    header.style.setProperty(
      'left',
      '0px',
      'important'
    );

    header.style.setProperty(
      'right',
      '0px',
      'important'
    );

    header.style.setProperty(
      'width',
      '100%',
      'important'
    );

    header.style.setProperty(
      'z-index',
      '10001',
      'important'
    );


    /* --------------------------------------------------------
       RESERVAR ESPACIO PARA TODO EL HEADER GROUP
    -------------------------------------------------------- */

    document.body.style.setProperty(
      'padding-top',
      totalHeight + 'px',
      'important'
    );


    /* Debug útil */
    console.log(
      'Fixed Header Group:',
      {
        announcement: announcementHeight,
        category: categoryHeight,
        header: headerHeight,
        total: totalHeight
      }
    );
  }


  function resetHeaderGroup() {

    const announcement =
      document.querySelector('.announcement-bar-wrapper');

    const category =
      document.querySelector('.category-menu-wrapper');

    const header =
      document.querySelector('header');


    [announcement, category, header].forEach(function (element) {

      if (!element) return;

      element.style.removeProperty('position');
      element.style.removeProperty('top');
      element.style.removeProperty('left');
      element.style.removeProperty('right');
      element.style.removeProperty('width');
      element.style.removeProperty('z-index');

    });


    document.body.style.removeProperty('padding-top');
  }


  /* ----------------------------------------------------------
     CARGA INICIAL
  ---------------------------------------------------------- */

  function initFixedHeader() {

    requestAnimationFrame(function () {

      requestAnimationFrame(function () {

        fixHeaderGroup();

      });

    });

  }


  /* Página normal */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initFixedHeader
    );

  } else {

    initFixedHeader();

  }


  /* ----------------------------------------------------------
     RESIZE
  ---------------------------------------------------------- */

  window.addEventListener(
    'resize',
    function () {

      clearTimeout(window.fixedHeaderResizeTimer);

      window.fixedHeaderResizeTimer =
        setTimeout(function () {

          fixHeaderGroup();

        }, 100);

    }
  );


  /* ----------------------------------------------------------
     SHOPIFY THEME EDITOR
  ---------------------------------------------------------- */

  document.addEventListener(
    'shopify:section:load',
    function () {

      setTimeout(function () {

        fixHeaderGroup();

      }, 200);

    }
  );


})();